import { useParams } from 'react-router-dom'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQuery } from '@percent/utility'
import { MonetaryVerificationsDetails } from './MonetaryVerificationsDetails'

export function MonetaryVerificationsDetailsContainer() {
  const { monetaryVerificationsService, adminService, validationSubmissionsService } = useServices()
  const { id } = useParams<{ id: string }>()

  const {
    data: monetaryVerification,
    isLoading: isMonetaryVerificationLoading,
    errorMessage: monetaryVerificationErrorMessage
  } = useQuery(
    ['v1/admin/monetary-donation-verifications', id],
    monetaryVerificationsService.getMonetaryVerification,
    { id: id ?? '' },
    { enabled: !!id }
  )

  const organisationId = monetaryVerification?.organisationId
  const validationSubmissionId = monetaryVerification?.validationSubmissionId

  const { data: organisation, isLoading: isOrganisationLoading } = useQuery(
    ['v1/admin/organisation', organisationId],
    adminService.getOrganisation,
    { id: organisationId },
    { enabled: !!organisationId }
  )

  const {
    data: validationSubmission,
    isLoading: isValidationSubmissionLoading,
    errorMessage: validationSubmissionErrorMessage
  } = useQuery(
    ['v1/admin/validation-submission', validationSubmissionId],
    validationSubmissionsService.getValidationSubmission,
    { id: validationSubmissionId! },
    { enabled: !!validationSubmissionId }
  )

  return (
    <MonetaryVerificationsDetails
      monetaryVerification={monetaryVerification}
      organisation={organisation}
      validationSubmission={validationSubmission}
      isLoading={isMonetaryVerificationLoading || isOrganisationLoading || isValidationSubmissionLoading}
      errorMessage={monetaryVerificationErrorMessage || validationSubmissionErrorMessage}
    />
  )
}
